import React from "react"
import { motion } from "framer-motion"

const FadeOnScroll = ({ children, className }) => {
  return (
<motion.div
  className={className}
  initial={{ opacity: 0, y: 10 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true, amount: 0.2 }} 
>
  {children}
</motion.div>
  )
}

export default FadeOnScroll
